export default __webpack_public_path__ + "static/emdrhslQ-13f15665dc669fcea377ce4ced411b4c.svg";